import { useState, useEffect } from 'react';
import { apiService } from '@/lib/api';

/**
 * Resolve feature gates for the current user. New features are gated to the
 * owner/admin account until rolled out publicly from Settings.
 *
 * Returns `null` while loading, then an object like { ask_drawready_assistant: true }.
 * Consumers should treat a missing/false key as "hidden".
 */
export function useFeatureGates(user) {
  const [gates, setGates] = useState(null);

  useEffect(() => {
    let active = true;
    if (!user?.id) { setGates({}); return; }
    apiService
      .getFeatureGates(user.id)
      .then((r) => { if (active) setGates(r.data?.gates || {}); })
      .catch(() => { if (active) setGates({}); });
    return () => { active = false; };
  }, [user?.id]);

  return gates;
}
